import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  title: string;
  description?: string;
  date?: string;
  publishDate?: string;
  readTime: string;
  children: React.ReactNode;
}

export default function BlogPost({ title, description, date, publishDate, readTime, children }: Props) {
  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ background: '#1B3A5C', padding: '60px 24px 48px' }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <Link to="/blog" style={{ color: '#2A9D8F', fontSize: 14, fontWeight: 600, textDecoration: 'none', display: 'inline-block', marginBottom: 20 }}>
            ← All Articles
          </Link>
          <h1 style={{ color: '#fff', fontSize: 32, fontWeight: 700, margin: '0 0 16px', lineHeight: 1.3 }}>
            {title}
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, margin: 0 }}>
            {date} · {readTime}
          </p>
        </div>
      </div>

      {/* Article body */}
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px' }}>
        <div style={{
          fontSize: 17,
          lineHeight: 1.75,
          color: '#1f2937',
        }}>
          {children}
        </div>
      </div>

      {/* CTA */}
      <div style={{ background: '#f0f9f8', borderTop: '1px solid #d1f0ec', padding: '48px 24px', textAlign: 'center' }}>
        <h3 style={{ color: '#1B3A5C', fontSize: 22, fontWeight: 700, marginBottom: 12 }}>
          Ready to build your compliant funding plan?
        </h3>
        <p style={{ color: '#4b5563', fontSize: 16, marginBottom: 24 }}>
          Upload your SIRS engineering report and generate a 30-year HB 913-compliant projection in under an hour.
        </p>
        <a
          href="/app"
          style={{
            background: '#2A9D8F', color: '#fff', padding: '14px 32px',
            borderRadius: 8, textDecoration: 'none', fontWeight: 700, fontSize: 15,
            display: 'inline-block',
          }}
        >
          Start Free →
        </a>
      </div>

      {/* Disclaimer */}
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '32px 24px' }}>
        <p style={{ color: '#9ca3af', fontSize: 13, lineHeight: 1.6, fontStyle: 'italic' }}>
          Disclaimer: FloridaSIRS.org generates financial projections based on data from your Structural Integrity Reserve Study. This article does not constitute legal, engineering, or financial advice. Consult your licensed professionals for compliance determinations. FloridaSIRS.org is not affiliated with the Florida Department of Business and Professional Regulation (DBPR).
        </p>
      </div>
    </div>
  );
}
